module.exports = __webpack_public_path__ + "static/img/CHICAGO_PAINT.af8a8bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/CHICAGO_PAINT.jpg
// module id = bSB0
// module chunks = 0